// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Contact-root-TMIUP {
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
  width: 100%;
  z-index: 1;
  height: auto;
}

.Contact-container-HYCP7 {
  margin: 0 auto;
  padding: 0 0 40px;
  max-width: var(--max-container-width);
}

@media screen and (max-width:1200px) {
  .Contact-container-HYCP7 {
    padding: 40px 0 40px;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/contact/Contact.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".root {\n  padding-left: 20px;\n  padding-right: 20px;\n  position: relative;\n  width: 100%;\n  z-index: 1;\n  height: auto;\n}\n\n.container {\n  margin: 0 auto;\n  padding: 0 0 40px;\n  max-width: var(--max-container-width);\n}\n\n@media screen and (max-width:1200px) {\n  .container {\n    padding: 40px 0 40px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Contact-root-TMIUP`,
	"container": `Contact-container-HYCP7`
};
module.exports = ___CSS_LOADER_EXPORT___;
